import script from "./merchantStatistics - 副本.vue?vue&type=script&setup=true&lang=js"
export * from "./merchantStatistics - 副本.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__